/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { getInfoPrintOrderApi, getOrderPrintHashApi } from './helpers';
import { GET_INFO_PRINT_ORDER, GET_PRINT_ORDER_HASH_INFO } from './constant';

function* takeGetOrderPrintHashSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getOrderPrintHashApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetInfoOrderPrintSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getInfoPrintOrderApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function* () {
  yield takeLatest(GET_PRINT_ORDER_HASH_INFO, takeGetOrderPrintHashSaga);
  yield takeLatest(GET_INFO_PRINT_ORDER, takeGetInfoOrderPrintSaga);
}

